import { IDeleteNovosNegociosArquivoUseCase } from "../../../presentation/useCases/delete/delete_novos_negocios_arquivo_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * DeleteNovosNegociosArquivoUseCase
 */

export class DeleteNovosNegociosArquivoUseCase implements IDeleteNovosNegociosArquivoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(idNovosNegociosArquivo: number): Promise<void> {
    await this.repository.deleteNovosNegociosArquivoById(idNovosNegociosArquivo);

  }
}
